/**
 * SINGLE SOURCE OF TRUTH FOR ALL PROJECTS - STAGING/TESTNET
 * Add new projects here - all other files will auto-update
 */

export const PROJECTS_CONFIG = [
    {
        id: "SIXR",
        name: "SIXR",
        shortName: "SIXR",
        imageSrc: "https://gems.vip/assets/alldetailpages/sixr/main-img.png",
        contracts: {
            preSale: "0x0EE53a802f7a0d9C89666fb11Aed70db5A2C00e9",
            claim: "0x6f373E20Dc6EA18e03b335D4DE1Fce41CB5eE1cE",
        },
        graph: {
            url: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/sixr-main/v1.1/gn",
            queryType: "standard",
        },
        contractType: "screx", // Which contract helper to use
        refLink: 'https://buysixr.gems.vip/?leader=',
        enabled: true,
        claimContractType: "luckify",
    },
    {
        id: "BYZANLINK",
        name: "Byzanlink",
        shortName: "Byzanlink",
        imageSrc: "https://gems.vip/assets/alldetailpages/byzanlink/main-img.png",
        contracts: {
            preSale: "0xDf5c53d1A6532a1349440758851B994348bafCed",
            claim: "0x917F407377f0fC2d0c09C369f0d8acD3254813C7",
        },
        graph: {
            url: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/byzenlink/v1.1/gn",
            queryType: "standard",
        },
        contractType: "screx", // Which contract helper to use
        refLink: 'https://buybyzanlink.gems.vip/?leader=',
        enabled: true,
        claimContractType: "luckify",
    },
    {
        id: "KAI",
        name: "KAI",
        shortName: "KAI",
        imageSrc: "https://gems.vip/assets/alldetailpages/kai/main-img.png",
        contracts: {
            preSale: "0x766FCcD76346cD34C2CfDb81e11902E9561a3d05",
            claim: "0x1fecC6F35785613488213A8968e33db578212B89",
        },
        graph: {
            url: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/kai-presale/prod/gn",
            queryType: "kai",
        },
        contractType: "kai",
        refLink: 'https://buykai.gems.vip/?leader=',
        enabled: true
    },
    {
        id: "NOYA",
        name: "Noya.ai",
        shortName: "Noya.ai",
        imageSrc: "https://gems.vip/assets/alldetailpages/noya/main-img.png",
        contracts: {
            preSale: "0xcf3bd5b1b02fa79b73b3cc017d51699f246a7b2d",
            claim: "0x798ac68aaaf5569956ed96a6e62ddb233ff5ceaa",
        },
        graph: {
            url: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/noya_ai/0.0.1/gn",
            queryType: "standard",
        },
        contractType: "screx", // Which contract helper to use
        refLink: 'https://buynoyaai.gems.vip/?leader=',
        enabled: true
    },
    {
        id: "XPROTOCOL",
        name: "Xprotocol",
        shortName: "Xprotocol",
        imageSrc: "https://gems.vip/assets/alldetailpages/xprotocol/main-img.png",
        contracts: {
            preSale: "0x9015294E96Dbe44A84Fa6E1e6eE79dd23CA65D94", // NEEDS TESTNET ADDRESS
            claim: "0x05123b52e23aefc79cf6c1ef2711b840c2044eda", // NEEDS TESTNET ADDRESS
        },
        graph: {
            url: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/xprotocolgraph/prod/gn",
            queryType: "standard",
        },
        contractType: "screx",
        refLink: 'https://buyxprotocol.gems.vip/?leader=',
        enabled: true
    },
    {
        id: "TIGA",
        name: "Tiga",
        shortName: "Tiga",
        imageSrc: "https://gems.vip/assets/alldetailpages/tiga/main-img.png",
        contracts: {
            preSale: "0xeecccfd9a1cbf9871f8b9d2e0b8d329faa7246a7", // NEEDS TESTNET ADDRESS
            claim: "0x52f5ad32b9cc0523e71f3145fcf2bcd94f711d8f", // NEEDS TESTNET ADDRESS
        },
        graph: {
            url: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/tiga_graph/0.0.1/gn",
            queryType: "standard",
        },
        contractType: "screx",
        refLink: 'https://buytiga.gems.vip/?leader=',
        enabled: true
    },
    // {
    //     id: "CHAINERS",
    //     name: "Chainers",
    //     shortName: "Chainers",
    //     imageSrc: "https://gems.vip/assets/alldetailpages/chainers/main-img.png",
    //     contracts: {
    //         preSale: "0x9990b5a321a5571262a2a82e278492c3ccbd8c69", // From old config
    //         claim: "0x9c3786d4107f7b0bcbf82ac1e2f7ec11be450a3c", // From old config
    //     },
    //     graph: {
    //         url: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/chainer-subgraph/prod/gn",
    //         queryType: "standard",
    //     },
    //     contractType: "screx",
    //     refLink: 'https://buychainers.gems.vip/?leader=',
    //     enabled: true
    // },
    {
        id: "SCREX",
        name: "Screx",
        shortName: "Screx",
        imageSrc: "https://gems.vip/assets/alldetailpages/screx/screxlogo.svg",
        contracts: {
            preSale: "0xe593109f04418f780c9d04260c85ee28e5b347e3", // From old config
            claim: "0x8720afbde3c7b92f6f928ad81554d62621403c3f", // From old config
            institution: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181", // ADDED FROM OLD CONFIG
        },
        graph: {
            url: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/screx-graph-2/v0.0.1-new-version/gn",
            queryType: "standard",
            institution: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/screx-graph-2/v0.0.1-new-version/gn", // ADDED
        },
        contractType: "screx",
        refLink: 'https://buyscrex.gems.vip/?leader=',
        // enabled: true

    },
    {
        id: "LUCKIFY",
        name: "Luckify",
        shortName: "Luckify",
        imageSrc: "/assets/luckify.svg",
        contracts: {
            preSale: "0x8BCa408fC6D0a12725F5B8D33a57052E63FF90F6", // From old config
            claim: "0x7Ed4FCD6D91AaA338A57d8B543DA50DF1b2bE514", // From old config
            institution: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181", // ADDED FROM OLD CONFIG
        },
        graph: {
            url: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/luckify-tokenOnly-mainnet-graph/v0.0.2-new-version/gn",
            queryType: "standard",
            institution: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/luckify-tokenOnly-mainnet-graph/api", // ADDED
        },
        contractType: "screx",
        claimContractType: "luckify",
        refLink: 'https://buyluckify.gems.vip/?leader=',
        // enabled: true
    },
    {
        id: "MATCHAIN",
        name: "Matchain",
        shortName: "Matchain",
        imageSrc: "/assets/matchain.svg",
        contracts: {
            preSale: "0x153956024667d29aA437Ef26413f3539eF0af42a", // From old config
            claim: "0x72097D31138751Ab614bad497Ad0aAE343c39a9b", // From old config
            institution: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181", // ADDED FROM OLD CONFIG
        },
        graph: {
            url: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/matchain-main/v0.0.1-new-version/gn",
            queryType: "matchain",
            institution: "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01", // ADDED
        },
        contractType: "screx",
        claimContractType: "matchain",
        refLink: 'https://buymatchain.gems.vip/?leader=',
        // enabled: true
    },
    {
        id: "RAIN",
        name: "Rain",
        shortName: "Rain",
        imageSrc: "/assets/rain.svg",
        contracts: {
            preSale: "0x89b0D65224b3c96430C72e3A8619B923aC866BC7", // From old config v3
            claim: "0x142A7864C0fd3A264673d0F236C99c0931b7133a", // From old config v3
            insurance: "0xBeFcE668Fc10bc6e335Dad50ed19095A47397E68", // ADDED
            versions: {
                v1: {
                    preSale: "0x29678cc6145a9FE173417DEf8797Fb22529d1a7e",
                    claim: "0x3d92A3c43F142d7eee687DC99489B390dd1e53db",
                },
                v2: {
                    preSale: "0x4c1433a23014a56c7341235298887e56a62B53BF",
                    claim: "0xB1544Ad821b5d74C8DBfC1b58EDEC76947B75cdA",
                },
                v3: {
                    preSale: "0x89b0D65224b3c96430C72e3A8619B923aC866BC7",
                    claim: "0x142A7864C0fd3A264673d0F236C99c0931b7133a",
                },
            },
        },
        graph: {
            url: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/rain-presale-without-Insurance-mainnet/api",
            queryType: "standard",
            versions: {
                v1: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/rain-presale-mainnet/v0.0.5-new-version/gn",
                v2: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/rain-mainnet-presale-insurance/v0.0.14-new-version/gn",
                v3: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/rain-presale-without-Insurance-mainnet/v0.0.3-new-version/gn",
            },
        },
        contractType: "rainV3",
        claimContractType: "rainV3",
        refLink: 'https://buyrain.gems.vip/?leader=',
    },
    {
        id: "ASTRANOVA",
        name: "Astra Nova",
        shortName: "Astra Nova",
        imageSrc: "https://gems.vip/assets/alldetailpages/astra/banner/token-logonew.png",
        contracts: {
            preSale: "0x24EF0ccaF8F3B4671FcE82005023E85120f6c026", // From old config (seems like v1)
            claim: "0x1890cF752f1be4D60f3b22168c7A6aFEbd9D74C7", // From old config
            insurance: "0xBeFcE668Fc10bc6e335Dad50ed19095A47397E68", // ADDED
            versions: {
                v1: {
                    preSale: "0x24EF0ccaF8F3B4671FcE82005023E85120f6c026",
                    claim: "0x1890cF752f1be4D60f3b22168c7A6aFEbd9D74C7",
                },
                v2: {
                    preSale: "0x5ac9755f906ca17EEBA8833A8D1d43fC3c2c000B", // NEEDS TESTNET ADDRESS
                    claim: "0xb403876ce7DEEfe827F6Dff03Fa672Fe60cC915D", // NEEDS TESTNET ADDRESS
                },
            },
        },
        graph: {
            url: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/astro-nova-live/v0.0.2-new-version/gn",
            queryType: "standard",
            versions: {
                v1: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/astro-nova-live/v0.0.2-new-version/gn",
                v2: "https://api.studio.thegraph.com/query/75549/sale-graph-v1/version/latest",
            },
        },
        contractType: "astroNovaV2",
        claimContractType: "astroNovaV2",
        refLink: 'https://buyastranova.gems.vip/?leader=',
    },
    {
        id: "NFA",
        name: "NFA",
        shortName: "NFA",
        imageSrc: "/assets/nfa.svg",
        contracts: {
            preSale: "0x8c61465F51C95635a43E4D0094f2329Ff5989992", // From old config
            claim: "0x84fD533E83B0b869034F3675DE0ABE00eE98a179", // From old config
            insurance: "0xBeFcE668Fc10bc6e335Dad50ed19095A47397E68",
        },
        graph: {
            url: "https://api.studio.thegraph.com/query/63987/nfa-mainnet/version/latest",
            queryType: "standard",
        },
        contractType: "screx",
        claimContractType: "nfa",
        refLink: 'https://nfa.gems.vip/?leader='

    },
    {
        id: "LEIA",
        name: "LEIA",
        shortName: "LEIA",
        imageSrc: "/assets/leia-icon.svg",
        contracts: {
            preSale: "0x3aEdC9075A8238A68BEc28495ea566f9abcA2840", // From old config
            claim: "0xB107140C5737Bfa6dBBe46db6b359Caf6e51524D", // From old config
            insurance: "0xEf9845956E5A68A28dCF04dAa1282acB85545e41",
        },
        graph: {
            url: "https://api.studio.thegraph.com/query/63987/lea-mainnet/version/latest",
            queryType: "standard",
        },
        contractType: "screx",
        claimContractType: "leia",
        refLink: 'https://leia.gems.vip/?leader='

    },
    {
        id: "OLYMPUS",
        name: "OLYMPUS",
        shortName: "OLYMPUS",
        imageSrc: "/assets/olympus.png",
        contracts: {
            preSale: "0xaDF3202480bD62F3dB150E27A0F811f999F253B9", // From old config
            claim: "0x1a11428b6F7903024B79aa7843d59895c817a3ad", // From old config
            insurance: "0x18c147D13839cDBD33058c2E3B4c0531D16003C5",
        },
        graph: {
            url: "https://api.studio.thegraph.com/query/63987/olympus-main/v-1",
            queryType: "standard",
        },
        contractType: "screx",
        claimContractType: "olympus",
        refLink: 'https://buy.olympus.vip/?leader='

    },
    {
        id: "INCENTIV",
        name: "INCENTIV",
        shortName: "INC",
        imageSrc: "/assets/incetive-card-logo.png",
        contracts: {
            preSale: "0x20361bC401EA01e5d6E01596c445Af1a48e1171b", // From old config
            claim: "0x27E00382b0C3eCd74d1505e8CD73706d79D0Bd54", // From old config
        },
        graph: {
            url: "https://api.studio.thegraph.com/query/63987/incentive-main/v1.1.1.1",
            queryType: "standard",
        },
        contractType: "screx",
        claimContractType: "incentiv",
        refLink: 'https://buy.incentiv.vip/?leader='

    },
    {
        id: "GEMS",
        name: "GEMS",
        shortName: "GEMS",
        imageSrc: "/assets/gemslogo.png",
        contracts: {
            preSale: "0x6236e15ab57bAA2d1465660Ef4Ec3B0A8D071090", // From old config
            claim: "0x96d7e90E6176466a0D882fc8BA6436021F1AeB06", // From old config
            staking: "0x6A1aa5ac35f38Bdb25BBD976E8eca942b23260b2",
            subscription: "0x80c162bd592f58ece113404befd5dd24fdf35a49",
        },
        graph: {
            url: "https://api.studio.thegraph.com/query/63987/gems-presale-main/0.4.1",
            queryType: "standard",
            staking: "https://gateway.thegraph.com/api/77dd7ccfbecca397482bc95055a6a0d5/subgraphs/id/GnKBhWQuj37bkuYpWoXKLL2qkJjnVi7V63DKbLuYWFB3",
            subscription: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/subscription-mainnet-graph/v0.0.1-new-version/gn",
            subscriptionV2: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/subscription-V2-main/v0.0.1-new-version/gn",
        },
        contractType: "screx",
        claimContractType: "gems",
        refLink: 'https://buy.gems.vip/?leader='

    },
    // {
    //     id: "NODEMINER",
    //     name: "Node Miner",
    //     shortName: "Node Miner",
    //     imageSrc: "/assets/nodeminer.svg",
    //     contracts: {
    //         preSale: "0x0F8d011aEc647ECD601dE4e3CD7774BeB03b4507", // From old config v2
    //         claim: "0x0F8d011aEc647ECD601dE4e3CD7774BeB03b4507", // From old config v2
    //         versions: {
    //             v1: {
    //                 claim: "0xcD761c06eD21504e31C733F48F6Efb8BE2bc7B8f",
    //             },
    //             v2: {
    //                 claim: "0x0F8d011aEc647ECD601dE4e3CD7774BeB03b4507",
    //             },
    //             v3: {
    //                 claim: "0x0F8d011aEc647ECD601dE4e3CD7774BeB03b4507", // NEEDS TESTNET ADDRESS IF DIFFERENT
    //             },
    //         },
    //     },
    //     graph: {
    //         url: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/miner-insurance/api",
    //         queryType: "miners",
    //         versions: {
    //             v1: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/miners-node-live/api",
    //             v2: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/node-miner-live-version2/api",
    //             v3: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/miner-insurance/api",
    //         },
    //     },
    //     contractType: "miners",
    //     claimContractType: "miners",
    //     customMethods: {
    //         getRoundCount: "currentWeek",
    //         claimMethod: {
    //             v1: "claim",
    //             v2: "claimAll",
    //             v3: "claimAll",
    //         },
    //     },
    // },
    {
        id: "DOP",
        name: "DOP",
        shortName: "DOP",
        imageSrc: "/assets/dashboardassets/ongoingcardone.svg",
        contracts: {
            preSale: "0x2B316b6E4fFD1984a2dE9b33E42787923d77F390",
            claim: "0x2cb197409ae65b344a611E2ab99A0E864EF28d4c",
            oldClaims: {
                rounds1_2: "0x08669B18fe3A661400ac8dddF837e90861BFf5B6",
                roundsGt2: "0x1B7168cA64fCd77fDF713767e6cDe2d7757241AB",
            },
            institution: "0x2E1858809393FaDb72D406Bb4E4699AD759e88fa", // ADDED FROM OLD CONFIG
        },
        graph: {
            url: "https://api.thegraph.com/subgraphs/name/saifdevblochain/presaledop",
            queryType: "dop",
            oldGraphUrl: "https://api.studio.thegraph.com/query/51954/dopgraphcombined/version/latest",
            oldGraphThreshold: 7,
            institution: "https://api.studio.thegraph.com/query/63987/institutionpresale-live/0.0.1", // ADDED
        },
        contractType: "screx",
        claimContractType: "dopLatest",
        refLink: 'https://buy.dop.vip/?leader='

    },
];

// Global tokens
export const GLOBAL_TOKENS = {
    tomi: "0x4385328cc4D643Ca98DfEA734360C0F596C83449", // From old config (MAINNET)
    busd: "0xdAC17F958D2ee523a2206206994597C13D831ec7", // USDT from old config (MAINNET)
    eth: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
    usdc: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48", // From old config (MAINNET)
    wbtc: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599", // From old config (MAINNET)
    gems: "0x3010ccb5419F1EF26D40a7cd3F0d707a0fa127Dc", // From old config (MAINNET)
    pepe: "0x6982508145454Ce325dDbE47a25d4ec3d2311933", // From old config (MAINNET)
    link: "0x514910771AF9Ca656af840dff83E8264EcF986CA", // From old config (MAINNET)
    uni: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984", // From old config (MAINNET)
    dop: "0x97A9a15168C22B3C137E6381037E1499C8ad0978", // From old config (MAINNET)

    weth: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",//MAINNET
};

// Legacy contracts (if needed)
export const LEGACY_CONTRACTS = {
    TomiContract: "0x4385328cc4D643Ca98DfEA734360C0F596C83449",
    CreateDopRound: "0x2D4e8121AeE68679054018037832947a3E0Bcf8A",
    CreateNFTRound: "0x1119c2d708E42Fb591FCe77283b0791a135855ba",
    CreateDopTomiRound: "0xf4Fa4f08811Ea1F79a809129192279d97D88EF51",
    CreateNFTTomiRound: "0xCFd7cB1528f32aDFFC40D2A7199E80799E4E4736",
    InstitutionPreSale: "0x2E1858809393FaDb72D406Bb4E4699AD759e88fa",
};